import { useContext } from 'react'
import { QuoteContext } from '../App'
import { IQuoteContext } from '../ts/QuoteContext'

export const useQuoteContext = (): IQuoteContext => {
   const context = useContext(QuoteContext)
   if (context === null) {
      throw new Error(
         'useQuoteContext must be used within a QuoteContext.Provider',
      )
   }
   return context
}
